import React, { useContext } from 'react';
import EmptyBackground from '../EmptyBackground';
import { getIsShortStatus } from '../../../DeviationViews/_helpers';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
export var StatusStageBackground = function (_a) {
    var deviation = _a.deviation;
    var isMobile = useContext(MobileContext);
    var isShortStatus = getIsShortStatus(deviation);
    var needsSubscription = useSubscriptionTier(deviation).needsSubscription;
    return (!isMobile || isShortStatus) && !needsSubscription ? (React.createElement(EmptyBackground, null)) : null;
};
StatusStageBackground.displayName = 'StatusStageBackground';
export default StatusStageBackground;
//# sourceMappingURL=Status.js.map